import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import HeaderOfPage from '../tools/headerOfPage';
import changeUrl from "../../hoc/changeur";
import ImageUploader from '../tools/uploaderImage';

export default function EditCampaignProduct() {
    const { t } = useTranslation();
    let cookie = getCookies();
    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [data, setData] = React.useState<any>(null);
    const [activeLang, setActiveLang] = useState<string>('en');
    const [saving, setSaving] = useState<boolean>(false);

    const languages = [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/campaignproducts/${Id}`;
            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: 'محصول کمپین با موفقیت به‌روزرسانی شد',
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            let errorMessage = 'خطا در به‌روزرسانی محصول کمپین';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }

    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/campaignproducts/${Id}`;
            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Ensure multilingual structure exists
            if (loadedData) {
                const ensureMultilingual = (field: any) => {
                    if (typeof field === 'string') {
                        return { ku: field, fa: field, en: field, ar: field, tr: field };
                    } else if (field && field.nl) {
                        field.ku = field.nl;
                        delete field.nl;
                        if (!field.tr) field.tr = '';
                        return field;
                    }
                    return field || { ku: '', fa: '', en: '', ar: '', tr: '' };
                };

                loadedData.name = ensureMultilingual(loadedData.name);
                loadedData.description = ensureMultilingual(loadedData.description);
                loadedData.url = ensureMultilingual(loadedData.url);
            }
            setData(loadedData)
        } catch (error: any) {
            let errorMessage = 'خطا در بارگذاری محصول کمپین';
            if (error.response?.data?.message) {
                errorMessage = typeof error.response.data.message === 'string'
                    ? error.response.data.message
                    : 'خطا در بارگذاری';
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Campaign',
            url: '/dashboard/Campaign'
        },
        {
            name: 'Campaign Products',
            url: '/dashboard/Campaign/Products'
        },
        {
            name: 'Edit Campaign Product',
            url: null
        }
    ]

    useEffect(() => {
        load();
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="ویرایش محصول کمپین"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
                        <form key={key}>
                            {/* Language Selector */}
                            <div className="mb-6">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    زبان / Language
                                </label>
                                <div className="flex gap-2 flex-wrap">
                                    {languages.map((lang) => (
                                        <button
                                            key={lang.code}
                                            type="button"
                                            onClick={() => setActiveLang(lang.code)}
                                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                                                ? 'bg-blue-600 text-white'
                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                }`}
                                        >
                                            {lang.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        value={data.name?.[activeLang] || ''}
                                        type="text"
                                        className={`${inputstyle} ${error != null && error['name'] != undefined ? 'bg-red-100' : ''}`}
                                        placeholder="نام محصول کمپین"
                                        onChange={(e) => {
                                            const nameValue = e.target.value;
                                            const slugValue = changeUrl(nameValue);
                                            setData({
                                                ...data,
                                                name: {
                                                    ...data.name,
                                                    [activeLang]: nameValue
                                                },
                                                url: {
                                                    ...data.url,
                                                    [activeLang]: slugValue
                                                }
                                            });
                                        }}
                                    />
                                    {error != null && error['name'] != undefined && (
                                        <small className="text-red-500">{error['name']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        توضیحات ({languages.find(l => l.code === activeLang)?.label})
                                    </label>
                                    <textarea
                                        value={data.description?.[activeLang] || ''}
                                        className={inputstyle}
                                        placeholder="توضیحات محصول کمپین (اختیاری)"
                                        rows={4}
                                        onChange={(e) => setData({
                                            ...data,
                                            description: {
                                                ...data.description,
                                                [activeLang]: e.target.value
                                            }
                                        })}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        URL ({languages.find(l => l.code === activeLang)?.label})
                                    </label>
                                    <input
                                        type="text"
                                        value={data.url?.[activeLang] || ''}
                                        className={`${inputstyle} ${error != null && error['url'] != undefined ? 'bg-red-100' : ''}`}
                                        placeholder="campaign-product-url"
                                        onChange={(e) => setData({
                                            ...data,
                                            url: {
                                                ...data.url,
                                                [activeLang]: e.target.value
                                            }
                                        })}
                                    />
                                    {error != null && error['url'] != undefined && (
                                        <small className="text-red-500">{error['url']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        قیمت (یورو) / Price (EUR)
                                    </label>
                                    <input
                                        type="number"
                                        dir="ltr"
                                        value={data.mainprice || ''}
                                        className={`${inputstyle} text-left`}
                                        placeholder="0.00"
                                        step="0.01"
                                        min="0"
                                        onChange={(e) => setData({
                                            ...data,
                                            mainprice: e.target.value ? parseFloat(e.target.value) : null
                                        })}
                                    />
                                </div>

                                <ImageUploader id={data._id} component="campaignproduct"></ImageUploader>

                                <div className="pt-4">
                                    <button
                                        type="button"
                                        onClick={save}
                                        disabled={saving}
                                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    >
                                        {saving ? 'در حال ذخیره...' : t('Update')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    )
}
